module.exports = __webpack_public_path__ + "img/map_Z4.1.C.03.9e2f7c0d.svg";